export default __webpack_public_path__ + "static/images/72241ef1869c74694951d3ef4f1a243a.png";